export class SecondaryClockUtils {

    static getChannelDisplayName = (index: number): string => {
        return `${index + 1} Канал управления`;
    };

    static getVoltageStyleByState = (state: string) => {
        const colors: Record<string, string> = {
            Off: 'none',
            Positive: '#ed6f6b',
            Negative: '#7096f8',
        };

        return {
            background: colors[state] ?? 'none',
        };
    };


    static calculateHandAngles = (hours: number, minutes: number) => {
        const hourAngle = (hours % 12) * 30 + minutes * 0.5;
        const minuteAngle = minutes * 6;
        return {hourAngle, minuteAngle};
    };

}
